import { useEffect, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { useSelector } from "react-redux";
import PdfModal from "../PdfModal";
import "./Factures.css";
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const Factures = () => {
    const apiUrl = process.env.REACT_APP_API_URL;
    const { token } = useSelector((state) => state.auth);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [factures, setFactures] = useState([]);
    const [pdfUrl, setPdfUrl] = useState(null);
    const currentYear = new Date().getFullYear();

    const [selectedYear, setSelectedYear] = useState(currentYear);
    const [selectedMonth, setSelectedMonth] = useState("all");
    const [currentIndex, setCurrentIndex] = useState(0);

    const openPdf = (file, categorie) => {
        setPdfUrl(`${apiUrl}/api/files/?categorie=${categorie}&file=${file}`);
    };
    const fetchFactures = async () => {
        try {
            setLoading(true);
            setMessage(null);

            const response = await fetch(`${apiUrl}/api/factures`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                throw new Error("Erreur lors du chargement des factures");
            }

            const data = await response.json();

            if (!data.status === "success") {
                setFactures([]);
            } else {
                setFactures(data.factures ?? []);
            }
        } catch (err) {
            console.error("Erreur fetch factures :", err);
            setMessage("Impossible de récupérer les factures.");
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (token) {
            fetchFactures();
        }
    }, [token]);
    useEffect(() => {
        setCurrentIndex(0);
    }, [selectedYear, selectedMonth, factures]);

    const availableYears = Array.from(
        new Set(
            factures.map(f =>
                new Date(f.createdAt).getFullYear()
            )
        )
    ).sort((a, b) => b - a);
    const filteredFactures = factures.filter((fact) => {
        const date = new Date(fact.createdAt);
        const year = date.getFullYear();
        const month = date.getMonth() + 1;

        if (year !== selectedYear) return false;
        if (selectedMonth !== "all" && month !== Number(selectedMonth)) return false;

        return true;
    });

    const currentFacture = filteredFactures[currentIndex] || null;
    const prevFacture = () => {
        setCurrentIndex((i) => Math.max(i - 1, 0));
    };

    const nextFacture = () => {
        setCurrentIndex((i) =>
            Math.min(i + 1, filteredFactures.length - 1)
        );
    };


    return (
        <div>
            <div className="facture-filters">
                {/* Sélecteur d'année */}
                <select
                    value={selectedYear}
                    onChange={(e) => setSelectedYear(Number(e.target.value))}
                >
                    {availableYears.map((year) => (
                        <option key={year} value={year}>
                            {year}
                        </option>
                    ))}
                </select>

                {/* Sélecteur de mois */}
                <select
                    value={selectedMonth}
                    onChange={(e) => setSelectedMonth(e.target.value)}
                >
                    <option value="all">Toute l’année</option>
                    <option value="1">Janvier</option>
                    <option value="2">Février</option>
                    <option value="3">Mars</option>
                    <option value="4">Avril</option>
                    <option value="5">Mai</option>
                    <option value="6">Juin</option>
                    <option value="7">Juillet</option>
                    <option value="8">Août</option>
                    <option value="9">Septembre</option>
                    <option value="10">Octobre</option>
                    <option value="11">Novembre</option>
                    <option value="12">Décembre</option>
                </select>
            </div>

            {filteredFactures.length === 0 && !loading && (
                <div>Aucune facture pour cette période.</div>
            )}

            {loading && <div>Chargement des factures…</div>}
            {message && <div className="error">{message}</div>}


            {!loading && filteredFactures.length === 0 && (
                <div>Aucune facture pour cette période.</div>
            )}

            {currentFacture && (
                <div className="facture-single">

                    <h3>
                        {currentFacture.titreFacture} – {currentFacture.numFacture}
                    </h3>

                    <div
                        className="pdf-thumbnail-facture"
                        onClick={() =>
                            openPdf(currentFacture.file, "facturesIntereseaux")
                        }
                    >
                        <Document
                            file={`${apiUrl}/api/files/?categorie=facturesIntereseaux&file=${currentFacture.file}`}
                        >
                            <Page pageNumber={1} width={200} />
                        </Document>
                        <button
                        className="btn-primary"
                        onClick={(e) => {
                          e.stopPropagation(); // 🔥 empêche l’ouverture de la modal
                          window.open(
                            `${process.env.REACT_APP_API_URL}/api/files/?categorie=facturesIntereseaux&file=${currentFacture.file}&download=1`,
                            "_blank"
                          );
                        }}
                      >
                        TÉLÉCHARGER
                      </button>
                    </div>

                    {/* Navigation */}
                    <div className="facture-navigation">
                        <button
                            onClick={prevFacture}
                            disabled={currentIndex === 0}
                        >
                            ‹
                        </button>

                        <span>
                            {currentIndex + 1} / {filteredFactures.length}
                        </span>

                        <button
                            onClick={nextFacture}
                            disabled={currentIndex === filteredFactures.length - 1}
                        >
                            ›
                        </button>
                    </div>
                </div>
            )}

            {pdfUrl && <PdfModal fileUrl={pdfUrl} onClose={() => setPdfUrl(null)} />}

        </div>
    )
}

export default Factures